import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import type { Faq } from "@/lib/faqs";

export function FAQAccordion({ items }: { items: Faq[] }) {
  return (
    <Accordion type="single" collapsible className="w-full divide-y divide-border border-y border-border">
      {items.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-0">
          <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-silver-light hover:text-copper hover:no-underline py-5">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-silver text-base leading-relaxed pb-6">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
